import styled from 'styled-components';

export const AdvancedSelectTableToolbar = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding-inline: 16px;
  padding-bottom: 8px;
  flex-wrap: wrap;
`;
